import {faPencil} from '@fortawesome/pro-solid-svg-icons';
import {type ReactAction} from '@netx/core/bootstrap';
import {canEditAssetViews} from '../enablers';
import {AssetViewActionLabel} from '../locales';
import {type IAsset} from '@netx/core-asset-next/schema';
import {type IAssetView} from '../schema';

export const assetViewActionEditIcon = faPencil;

export interface AssetViewActionEditParams extends Partial<ReactAction> {}

/**
 * Edit asset view
 * @param params
 * @returns Action
 */
export const assetViewActionEdit = (
	asset: IAsset,
	view: IAssetView,
	params: AssetViewActionEditParams = {},
): ReactAction => ({
	name: 'asset-view-edit',
	cb: () => {},
	enableTest: () => canEditAssetViews(asset, view),
	icon: assetViewActionEditIcon,
	get label() {
		return AssetViewActionLabel.EDIT;
	},
	...params,
});
